import { components } from "@certn/legacy-api/generated-schemas/people";
import { t } from "i18next";
import { date, object, string } from "yup";

import { PassportInputField } from "./PassportInputField";
import { PassportSummaryField } from "./PassportSummaryField";
import { FieldType } from "../types";

export function PassportField(
  field: components["schemas"]["PassportCheckField"]
): FieldType<components["schemas"]["PassportCheckField"]> {
  return {
    field,
    inputElement: <PassportInputField key={field.name} field={field} />,
    summaryElement: () => (
      <PassportSummaryField key={field.name} field={field} />
    ),
    initialValue: {
      ...field.value,
      id: field.value?.id,
      document_expiration: field.value?.document_expiration ?? "",
      document_issuing_country: field.value?.document_issuing_country ?? "",
      document_issuing_province_state:
        field.value?.document_issuing_province_state ?? "",
      document_number: field.value?.document_number ?? "",
    } as components["schemas"]["PassportCheckField"]["value"],
    schema: passportFieldSchema,
  };
}

export const passportFieldSchema = object().shape({
  id: string().required(t("This field is required")),
  document_number: string().required().label(t("ID number")),
  document_expiration: date()
    .required()
    .label(t("ID expiration"))
    .min(new Date(), t("Invalid date")),
  document_issuing_country: string().required().label(t("Issuing country")),
  document_issuing_province_state: string()
    .required()
    .label(t("Issuing province, state or territory")),
});
